<!-- <template>
    <div class="product-details-des mt-40 mb-60">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="product__details-des-tab">
              <ul class="nav nav-tabs" id="productDesTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button 
                    class="nav-link active" 
                    id="des-tab" 
                    data-bs-toggle="tab" 
                    data-bs-target="#des" 
                    type="button" 
                    role="tab" 
                    aria-controls="des" 
                    aria-selected="true">Description 
                 </button>
                </li> -->
                <!--
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="aditional-tab" data-bs-toggle="tab" data-bs-target="#aditional" type="button" role="tab" aria-controls="aditional" aria-selected="false">Additional information</button>
                </li>

                 <li class="nav-item" role="presentation">
                  <button class="nav-link" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab" aria-controls="review" aria-selected="false">Reviews (1) </button>
                </li> -->
              <!-- </ul>
            </div>
          </div>
        </div>
        <div class="tab-content" id="prodductDesTaContent">
          <div class="tab-pane fade active show" id="des" role="tabpanel" aria-labelledby="des-tab">
            <div class="product__details-des-wrapper">
              <p class="des-text mb-35" v-html="product.product_details"></p>
          
            </div>
          </div>
          <div class="tab-pane fade" id="aditional" role="tabpanel" aria-labelledby="aditional-tab">
            <div class="product__desc-info">
              <ul>
                <li v-for="(item, i) in product.additionalInformation" :key="i">
                  <h6>{{ item.key }}</h6>
                  <span>{{ item.value }}</span>
                </li>
              </ul>
            </div>
          </div>
           -->
          <!-- <div class="tab-pane fade" id="review" role="tabpanel" aria-labelledby="review-tab">
            <div class="product__details-review">
              <div class="row">

                <div class="col-xl-4">
                  <div class="review-rate">
                    <h5>{{ averageRating(product.reviews).toFixed(2) }}</h5>
                    <div class="review-star">
                      <a href="#"><i class="fas fa-star"></i></a>
                      <a href="#"><i class="fas fa-star"></i></a>
                      <a href="#"><i class="fas fa-star"></i></a>
                      <a href="#"><i class="fas fa-star"></i></a>
                      <a href="#"><i class="fas fa-star"></i></a>
                    </div>
                    <span class="review-count">{{ product.reviews.length }} Review</span>
                  </div>
                </div>
                <div class="col-xl-8">
                  <div class="review-des-infod">
                    <h6>{{ product.reviews.length }} review for "<span>{{ product.title }}</span>"</h6>
                    <div v-for="(item) in product.reviews" :key="item.id" class="review-details-des">
                      <div class="author-image mr-15">
                        <a href="#">
                          <img :src="item.user" alt="user">
                        </a>
                      </div>
                      <div class="review-details-content">
                        <div class="str-info">
                          <div class="review-star mr-15">
                            <a href="#"><i class="fas fa-star"></i></a>
                            <a href="#"><i class="fas fa-star"></i></a>
                            <a href="#"><i class="fas fa-star"></i></a>
                            <a href="#"><i class="fas fa-star"></i></a>
                            <a href="#"><i class="fas fa-star"></i></a>
                          </div>
                          <div class="add-review-option">
                            <a href="#">Add Review</a>
                          </div>
                        </div>
                        <div class="name-date mb-30">
                          <h6>{{ item.name }} – <span> {{ item.date }}</span></h6>
                        </div>
                        <p>A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in <br> voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12">
                  <div class="product__details-comment">
                    <div class="comment-title mb-20">
                      <h3>Add a review</h3>
                      <p>Your email address will not be published. Required fields are marked *</p>
                    </div>
                    <div class="comment-rating mb-20">
                      <span>Overall ratings</span>
                      <ul>
                        <li><a href="#"><i class="fas fa-star"></i></a></li>
                        <li><a href="#"><i class="fas fa-star"></i></a></li>
                        <li><a href="#"><i class="fas fa-star"></i></a></li>
                        <li><a href="#"><i class="fas fa-star"></i></a></li>
                        <li><a href="#"><i class="fas fa-star"></i></a></li>
                      </ul>
                    </div>
                    <div class="comment-input-box">
                     
                      <form-product-review />
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
 -->
<!-- 
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { defineProps } from 'vue';

  defineProps({
    product: {
      type: Object,
      required: true,
      default: () => ({
        description: "",
        additionalInformation: [],
        reviews: [],
        title: "",
      }),
    },
  });
  </script>
  





   -->




   <template> 
  <div class="product-details-des mt-5 mb-5"> 
    <div class="container"> 
      <div class="row"> 
        <div class="col-xl-12"> 
          <div class="product__details-des-tab"> 
            <ul class="nav nav-tabs border-bottom" id="productDesTab" role="tablist"> 
              <li class="nav-item" role="presentation" v-if="product.product_details"> 
                <button  
                  class="nav-link"  
                  :class="{ 'active': activeTab === 'des' }"  
                  id="des-tab"  
                  data-bs-toggle="tab"  
                  data-bs-target="#des"  
                  type="button"  
                  role="tab"  
                  aria-controls="des"  
                  :aria-selected="activeTab === 'des'"
                  @click="handleTabClick('des')"> 
                  <i class="fas fa-file-alt me-2"></i>Description 
                </button> 
              </li> 
              <li class="nav-item" role="presentation" v-if="product.product_specification"> 
                <button  
                  class="nav-link"  
                  :class="{ 'active': activeTab === 'spec' }" 
                  id="spec-tab"  
                  data-bs-toggle="tab"  
                  data-bs-target="#spec"  
                  type="button"  
                  role="tab"  
                  aria-controls="spec"  
                  :aria-selected="activeTab === 'spec'"
                  @click="handleTabClick('spec')"> 
                  <i class="fas fa-list-ul me-2"></i>Specifications 
                </button> 
              </li> 
              <li class="nav-item" role="presentation" v-if="product.product_addinfo"> 
                <button  
                  class="nav-link"  
                  :class="{ 'active': activeTab === 'additional' }" 
                  id="additional-tab"  
                  data-bs-toggle="tab"  
                  data-bs-target="#additional"  
                  type="button"  
                  role="tab"  
                  aria-controls="additional"  
                  :aria-selected="activeTab === 'additional'"
                  @click="handleTabClick('additional')"> 
                  <i class="fas fa-info-circle me-2"></i>Additional Information 
                </button> 
              </li> 
            </ul> 
          </div> 
        </div> 
      </div> 
       
      <div class="tab-content mt-4" id="prodductDesTaContent"> 
        <!-- Description Tab --> 
        <div  
          class="tab-pane fade"  
          :class="{ 'active show': activeTab === 'des' }" 
          id="des"  
          role="tabpanel"  
          aria-labelledby="des-tab" 
          v-if="product.product_details"> 
          <div class="product__details-des-wrapper"> 
            <div class="description-content" v-html="product.product_details"></div> 
          </div> 
        </div> 

        <!-- Specifications Tab --> 
        <div  
          class="tab-pane fade"  
          :class="{ 'active show': activeTab === 'spec' }" 
          id="spec"  
          role="tabpanel"  
          aria-labelledby="spec-tab" 
          v-if="product.product_specification"> 
          <div class="product__specification-wrapper"> 
            <div class="specification-content" v-html="product.product_specification"></div> 
          </div> 
        </div> 

        <!-- Additional Information Tab --> 
        <div  
          class="tab-pane fade"  
          :class="{ 'active show': activeTab === 'additional' }" 
          id="additional"  
          role="tabpanel"  
          aria-labelledby="additional-tab" 
          v-if="product.product_addinfo"> 
          <div class="product__additional-wrapper"> 
            <div class="additional-content" v-html="product.product_addinfo"></div> 
          </div> 
        </div>
 
        <!-- Empty State --> 
        <div v-if="!product.product_details && !product.product_specification && !product.product_addinfo" 
class="empty-state text-center py-5"> 
          <i class="fas fa-info-circle fa-3x text-muted mb-3"></i> 
          <p class="text-muted">No product information available at this time.</p> 
        </div> 
      </div> 
    </div> 
  </div> 
</template> 
 
<script setup> 
import { ref, onMounted, watch } from 'vue'; 

const props = defineProps({ 
  product: { 
    type: Object, 
    required: true, 
    default: () => ({ 
      product_details: "", 
      product_specification: "", 
      product_addinfo: "", 
    }), 
  }, 
}); 

// Track active tab
const activeTab = ref('des');

// Initialize active tab based on available data
const initializeActiveTab = () => {
  if (props.product.product_details) {
    activeTab.value = 'des';
  } else if (props.product.product_specification) {
    activeTab.value = 'spec';
  } else if (props.product.product_addinfo) {
    activeTab.value = 'additional';
  }
};

// Watch for product changes
watch(() => props.product, () => {
  initializeActiveTab();
}, { deep: true, immediate: true });

// Handle tab click
const handleTabClick = (tabName) => {
  activeTab.value = tabName;
  
  // Also trigger Bootstrap tab if available
  if (typeof window !== 'undefined' && window.bootstrap) {
    const tabElement = document.querySelector(`#${tabName}-tab`);
    if (tabElement) {
      const tab = new window.bootstrap.Tab(tabElement);
      tab.show();
    }
  }
};

onMounted(() => {
  initializeActiveTab();
});
</script>
 
<style scoped> 
.product-details-des { 
  background: #fff; 
  padding: 40px 0; 
} 
 
.product__details-des-tab { 
  border-bottom: 2px solid #e9ecef; 
} 
 
.nav-tabs { 
  border-bottom: none; 
} 
 
.nav-tabs .nav-link { 
  border: none; 
  border-bottom: 3px solid transparent; 
  color: #666; 
  font-weight: 500; 
  padding: 15px 25px; 
  transition: all 0.3s; 
  background: transparent; 
} 
 
.nav-tabs .nav-link:hover { 
  border-bottom-color: #007bff; 
  color: #007bff; 
  background: #f8f9fa; 
} 
 
.nav-tabs .nav-link.active { 
  border-bottom-color: #007bff; 
  color: #007bff; 
  background: transparent; 
  font-weight: 600; 
} 
 
.tab-content { 
min-height: 200px; 
} 
.description-content, 
.specification-content, 
.additional-content { 
line-height: 1.8; 
color: #333; 
font-size: 15px; 
} 
.description-content :deep(p), 
.specification-content :deep(p), 
.additional-content :deep(p) { 
margin-bottom: 15px; 
} 
.description-content :deep(ul), 
.specification-content :deep(ul), 
.additional-content :deep(ul) { 
padding-left: 20px; 
margin-bottom: 15px; 
} 
.description-content :deep(li), 
.specification-content :deep(li), 
.additional-content :deep(li) { 
margin-bottom: 8px; 
line-height: 1.8; 
} 
.description-content :deep(h1), 
.specification-content :deep(h1), 
.additional-content :deep(h1), 
.description-content :deep(h2), 
.specification-content :deep(h2), 
.additional-content :deep(h2), 
.description-content :deep(h3), 
.specification-content :deep(h3), 
.additional-content :deep(h3) { 
margin-top: 25px; 
margin-bottom: 15px; 
color: #333; 
font-weight: 600; 
} 
.description-content :deep(table), 
.specification-content :deep(table), 
.additional-content :deep(table) { 
width: 100%; 
border-collapse: collapse; 
margin: 20px 0; 
} 
.description-content :deep(table th), 
.specification-content :deep(table th), 
.additional-content :deep(table th), 
.description-content :deep(table td), 
.specification-content :deep(table td), 
.additional-content :deep(table td) { 
border: 1px solid #dee2e6; 
padding: 12px; 
text-align: left; 
} 
 
.description-content :deep(table th), 
.specification-content :deep(table th), 
.additional-content :deep(table th) { 
  background-color: #f8f9fa; 
  font-weight: 600; 
} 
 
.empty-state { 
  padding: 60px 20px; 
} 
</style> 